import React, { useState } from "react";

/* CSS */
import "../assets/css/style.css";
import "../assets/css/responsive.css";
import "../assets/css/animation.css";
 import { MdTrendingUp } from "react-icons/md";

/*Features Images */
import featuresImg1 from "../assets/images/box-icon/s-1.png";
import featuresImg2 from "../assets/images/box-icon/s-2.png";
import featuresImg3 from "../assets/images/box-icon/s-3.png";
import featuresImg4 from "../assets/images/box-icon/s-4.png";
import featuresImg5 from "../assets/images/box-icon/s-5.png";
import featuresImg6 from "../assets/images/box-icon/s-6.png";

/*how works Images */
import howicon1 from "../assets/images/box-icon/h-1.png";
import howicon2 from "../assets/images/box-icon/h-2.png"; 
import howicon3 from "../assets/images/box-icon/h-3.png"; 
import howicon4 from "../assets/images/box-icon/h-4.png";  
 

/*Timeline Images */
import timelineimg1 from "../assets/images/box-icon/r-1.png";
import timelineimg2 from "../assets/images/box-icon/r-2.png";
import timelineimg3 from "../assets/images/box-icon/r-3.png";
import timelineimg4 from "../assets/images/box-icon/r-4.png";
/* ===================== DATA ===================== */

const cardsData = [
  {
    title: "Equity Growth Projects",
    desc: "We design equity-focused trading models that target sustainable growth through sector analysis, stock selection, and momentum confirmation. Each project is built to balance opportunity with calculated risk.",
  },
  {
    title: "Market Intelligence Projects",
   desc: "These projects revolve around deep market research, price behavior studies, and data-backed forecasting. The goal is to decode market sentiment and identify high-probability trading zones.",
  },
  {
    title: "Global Forex Initiatives",
   desc: "Our Forex projects focus on major and minor currency pairs with liquidity-driven strategies. We analyze macro trends and price structures to navigate fast-moving currency markets.",
  },
  {
    title: "Stock Opportunity Programs",
    desc: "This segment targets short-term swings and long-term positioning in the stock market. Strategies are structured to adapt to both trending and consolidating market conditions.",
  },
  {
    title: "Technical Strategy Labs",
    desc: " Here we test and refine advanced chart patterns, indicators, and price action models. These projects help improve trade accuracy, timing, and consistency.",
  },
  {
    title: "Capital & Portfolio Frameworks",
    desc: "Focused on capital preservation and smart diversification, these projects aim to build stable portfolios. Risk allocation and asset balance remain the core foundation of every framework.",
  },
];
const pageData = {
  banner: {
    tagline: " Invest Smart, Trade Smarter",
    heading: "Trade Smarter. Move Faster. Access Global Markets ",
    highlight: "With Confidence.",
    description:
      "Bit Wave Capital is a next-generation trading platform designed for modern traders. We empower individuals and professionals to trade across Crypto, Forex, Stocks, Indices, and Commodities with precision and discipline.",
    button: {
      label: "Bussiness Plan",
      href: "/images/Bussiness-plan/bwc.pdf",
    }, 
  },

  about: { 
    tag: "ABOUT Bit Wave Capital",
    title: "Building Better Traders, One Trade At a Time", 
    paragraphs: [
      "Bit Wave Capital was founded with a single vision — to create a transparent, intelligent, and trader-focused ecosystem. We understand that trading is not just about buying and selling assets; it is about strategy, discipline, and risk control. Our approach focuses on data-driven decision making, practical market analysis, and continuous learning.",
      "We understand that trading is not just about buying and selling assets; it is about strategy, discipline, and risk control. Our approach focuses on data-driven decision making, practical market analysis, and continuous learning",
    ], 
  },

  features: {
    tag: "Our Services",
    title: "Comprehensive Services for ",
    highlight: "Every Trader",
    items: [
      { icon: featuresImg1, title: "Equity Trading",
         desc: "We offer structured insights and strategies for equity markets, helping traders identify high-potential stocks while managing downside risk effectively." },
      { icon: featuresImg2, title: "Market Analysis",
         desc: "Our market analysis combines technical indicators, price action, and macro insights to deliver clear market direction across multiple asset classes." },
      { icon: featuresImg3, title: "Forex Trading",
         desc: "Navigate global currency markets with confidence using our disciplined Forex strategies designed for volatility and liquidity." },
      { icon: featuresImg4, title: "Stock Market",
         desc: "From blue-chip stocks to emerging opportunities, our stock market approach focuses on trend identification and capital preservation." },
      { icon: featuresImg5, title: "Technical Analysis",
         desc: "We apply advanced chart patterns, indicators, and trend structures to identify precise entry and exit points." },
      { icon: featuresImg6, title: "Portfolio Management",
        desc: "Diversification and risk balance are key. Our portfolio management approach focuses on sustainable growth across multiple markets." },
    ],
  },

  whyFuture: {
    tag: "Why choose  Bit Wave Capital",
    title: "The Future of  ",
    highlight: "Intelligent Trading",
  },

  howItWorks: {
    tag: "How it works",
    title: "Step-by-Step Trade & Earn with",
    highlight: " Bit Wave Capital",
  },

  projects: {
    tag: "Our Technology",
    title: "Powering Trades with ",
    highlight: "Smart Technology",
  },
};

const whyFutureData = [
  {
    title: "Data-Driven Decision Making",
    description:
      "We analyze market behavior using advanced data models to reduce emotional trading and improve consistency.",
  },
  {
    title: "User-Focused Solutions",
    description:
      "Our platform is designed with traders in mind — simple, efficient, and focused on real market needs.",
  },
  {
    title: "Latest Trading Technology",
    description:
      "We continuously upgrade our systems to match the evolving pace of global financial markets.",
  },
  {
    title: "Risk Management First Approach",
    description:
      "Capital protection is our top priority. Every strategy is built with defined risk parameters to help traders minimize losses and trade with long-term sustainability.",
  },
];

const howItWorksData = [
  { 
     icon: howicon1,
    step: "Step 1",
    title: "Create Your Account",
    description:
      "Register securely on Bit Wave Capital and complete a smooth onboarding process within minutes. Once signed up, you gain access to our complete trading ecosystem designed for both beginners and professionals.",
  },
  {
      icon: howicon2,
    step: "Step 2",
    title: "Explore Market Insights",
    description:
      " Dive into detailed market analysis, expert strategies, and high-quality trade setups. Our insights cover multiple asset classes, helping you understand market direction before placing any trade.",
  },
  {
      icon: howicon3,
    step: "Step 3",
    title: "Start Trading & Grow",
    description:
      "Execute trades with confidence using structured strategies and real-time market intelligence. Risk management remains a core focus, ensuring disciplined trading and long-term capital growth.",
  },
  {
      icon: howicon4,
    step: "Step 4",
    title: "Performance & Earn",
    description:
      "Monitor your trading performance through consistent evaluation and market review. Refine your approach, adapt to market conditions, and grow steadily with a professional trading mindset.",
  },
];

const timelineSectionData = {
  tag: "roadmap",
  heading: {
    normal: "Our",
    highlight: "Timeline",
  },
  timelines: [
    {
      phase: "Phase 1",
      title: "Foundation & Launch",
      icon: timelineimg1,
      points: [
        "Platform development",
        "Strategy framework creation",
        "Market research & testing",
        "Community building", 
      ],
    },
    {
      phase: "Phase 2",
      title: "Marketplace Expansion",
      icon: timelineimg2,
      points: [
        "Multi-asset trading coverage",
        "Advanced analytical tools",
        "Enhanced user experience",
        "Security improvements", 
      ],
    },
    {
      phase: "Phase 3",
      title: "Ecosystem Growth",
      icon: timelineimg3,
      points: [
        "Global market access",
        "Strategic partnerships",
        "Education & learning resources",
        "Performance optimization", ,
      ],
    },
    {
      phase: "Phase 4",
      title: "Advanced Features",
      icon: timelineimg4,
      points: [
        "AI-assisted market insights",
        "Automated risk tools",
        "Advanced portfolio tracking",
        "Long-term scalability", 
      ],
    },
  ],
}; 

const faqSectionData = {
  tag: "Faq",
  heading: {
    normal: "Frequently Asked",
    highlight: "Questions",
  },
  items: [
    {
      title: "1. What is Bit Wave Capital?",
      content:
        "Bit Wave Capital is a multi-asset trading platform that provides market analysis, trading strategies, and insights across global financial markets. Our goal is to support traders in making informed, data-driven decisions.",
    },
    {
      title: "2. Is trading risky?",
      content:
        "Yes, all forms of trading involve market risk due to price fluctuations and volatility. We strongly emphasize risk management and disciplined trading to help manage potential losses.",
    },
    {
      title: "3. Do you provide guaranteed returns?",
      content:
        "No, we do not offer or promise guaranteed profits. Trading outcomes depend on market conditions, strategy execution, and individual risk management.",
    },
    {
      title: "4. Who can use Bit Wave Capital?",
      content:
        "Our platform is suitable for beginners, intermediate traders, and experienced professionals. We offer insights and strategies designed to support traders at different experience levels.",
    },
    {
      title: "5. What markets do you cover?",
      content:
        "We cover a wide range of markets including Crypto, Forex, Stocks, Indices, and Commodities. This multi-market approach allows traders to explore diverse opportunities under one platform.",
    },
  ],
};


/* ===================== COMPONENT ===================== */

const BannerSection = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const { banner, about, features, whyFuture, howItWorks, projects } = pageData;

  return (
    <>
      {/* ================= BANNER ================= */}
      <section className="flat-pages-title" id="home"> 
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 ">
              <div className="pages-title">
                <div className="sec-title-banner"><MdTrendingUp size={20} className="all-icon" />{banner.tagline}</div>
                <h1>
                  {banner.heading}
                  <span className="s1">{banner.highlight}</span>
                </h1>
                <p>{banner.description}</p>
                <div className="flat-button banner-btn">
                  <a href={banner.button.href} target="blank" className="gradient-color tf-button">
                    {banner.button.label}
                  </a> 
                </div>
              </div>
            </div>
            <div className="col-lg-5 mx-auto text-center">
              <div className="tm-about-img-wrap">
                <div className="tm-about-img">
                  <img src="/images/logo/circle.png" className="img-fluid img-11" alt="" />
                  <img src="/images/logo/logo.png" className="img-fluid img-12" alt=""
                  />
                </div>
              </div>
            </div> 
          </div>
        </div>
      </section>

      {/* ================= ABOUT ================= */}
      
      <section className="about-us" id="about">
         <div class="marquee-container">
    <div class="marquee-track">
     <div class="marquee-item"><span>📈</span>Day Trading</div>  
      <div class="marquee-item"><span>💼</span>Position Trading</div>  
      <div class="marquee-item"><span>📉</span>Intraday Trading</div>
      <div class="marquee-item"><span>📆</span>Long-Term Investing</div>
      <div class="marquee-item"><span>🧠</span>Technical Trading</div>
      <div class="marquee-item"><span>📚</span>Fundamental Trading</div>
      <div class="marquee-item"><span>🔁</span>Stock Trading</div> 
      <div class="marquee-item"><span>📐</span>Price Action Trading</div>
      <div class="marquee-item"><span>🧮</span>Quantitative Trading</div>
      <div class="marquee-item"><span>💱</span>Forex Trading</div>
      <div class="marquee-item"><span>🪙</span>Crypto Trading</div>
      <div class="marquee-item"><span>🏦</span>Equity Trading</div>
      <div class="marquee-item"><span>📦</span>Options Trading</div>
      <div class="marquee-item"><span>📜</span>Futures Trading</div>
      <div class="marquee-item"><span>🌍</span>Commodities Trading</div>
    </div>
  </div>
        <div className="container">
          <div className="row align-items-center row-reverse">
            <div className="col-md-5 mx-auto text-center">
              <div class="about-left">
						  <img src="images/about/about-main.png" alt="About NFT" className="img-fluid" />
					</div> 
            </div>
            <div className="col-lg-7">
              <div className="about-content">
                <div className="section_title">
                  <div className="sec-title"><MdTrendingUp size={20} className="all-icon " /> {about.tag}</div>
                  <h2 className="title all-h2 mb-2">
                    {about.title} 
                    {/* <span className="s1">{about.highlight}</span> */}
                  </h2>
                </div>
                {about.paragraphs.map((text, i) => (
                  <p key={i}>{text}</p>
                ))} 
              </div>
            </div>
          </div> 
            <div class="row">
              <div class="col-lg-12">
              <div className="main-mission about-content">
                <div className="about-item">
                  <div className="icon">
                    <img src="images/about/mission.svg" alt="" />
                  </div>
                  <div className="content">
                    <h4 className="all-h4">Our Mission</h4>
                    <p>
                      At Bit Wave Capital, our mission is to democratize professional trading
                      by providing a transparent, data-driven ecosystem. We aim to empower
                      traders globally with advanced analytical tools and strategic
                      frameworks, ensuring that every trade is backed by discipline and
                      intelligence. We are committed to fostering a community where risk
                      control and continuous learning pave the way for sustainable financial
                      growth and trading excellence.
                    </p>
                  </div>
                </div>
                <div className="about-item">
                  <div className="icon">
                    <img src="images/about/Vision.svg" alt="" />
                  </div>
                  <div className="content">
                    <h4 className="all-h4">Our Vision</h4>
                    <p>
                      To become the world’s most trusted hub for intelligent trading, where
                      technology meets human expertise. We envision a future where financial
                      markets are accessible and understandable for everyone, replacing guesswork
                      with precision. By setting a new standard in market analysis and trader
                      education, Bit Wave Capital aspires to lead the next generation of
                      successful, independent, and disciplined global traders.
                    </p>
                  </div>
                </div>
              </div>
              </div> 
		 
			</div>
        </div>
      </section> 


{/* ================= trading-Bot ================= */}
      <section className="trading-Bot" id="tradingBot">
        <div className="container">
          <div className="row align-items-center about-content">
            <div className="col-lg-6 ">
              <div className="section_title">
                <div className="sec-title"><MdTrendingUp size={20} className="all-icon" /> Trading Bot</div>
                <h2 className="title all-h2">
                  Robotic Ai
                  <span className="s1">Trading Bot</span>
                </h2>
              </div>
              <p>We are trading by making
                accurate predictions with
                the help of an Ai Robotic
                Bot, which increases the
                chances of earning higher
                profits.</p>
            </div>
            <div class="col-lg-6">
              <div class="right-image">
                <div class="glow"></div>
                <img src="/images/about/trading-bot.jpeg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* ================= FEATURES ================= */}
      <section className="our-features" id="Services">
        <div className="container">
          <div className="section_title text-center">
            <div className="sec-title mx-auto"><MdTrendingUp size={20} className="all-icon" />{features.tag}</div>
            <h2 className="title all-h2">
              {features.title}
              <span className="s1">{features.highlight}</span>
            </h2>
          </div>

          <div className="feature-grid">
            {features.items.map((item, index) => (
              <div className="feature-box" key={index}>
                <div className="icon-circle">
                  <div className="border-icon">
                    <img src={item.icon} alt={item.title} />
                  </div>
                </div>
                <h4 className="all-h4">{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
 


      {/* ================= WHY FUTURE NFT ================= */}
      <section className="why-future-nft" id="whychoose">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="left-content">
                <div className="section_title">
                  <div className="sec-title"><MdTrendingUp size={20} className="all-icon" />{whyFuture.tag}</div>
                  <h2 className="title all-h2">
                    {whyFuture.title}
                    <span className="s1">{whyFuture.highlight}</span>
                  </h2>
                </div>

                {whyFutureData.map((item, index) => (
                  <div className="feature" key={index}>
                    <div className="icon">✓</div>
                    <div className="text">
                      <h4 className="all-h4">{item.title}</h4>
                      <p>{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-6">
              <div className="right-image">
                <div className="glow"></div>
                <img src="/images/about/why-choose.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= HOW IT WORKS ================= */}
      <section className="How-it-works" id="howItWorks">
        <div className="container">
          <div className="section_title text-center">
            <div className="sec-title mx-auto"><MdTrendingUp size={20} className="all-icon" />{howItWorks.tag}</div>
            <h2 className="title all-h2">
              {howItWorks.title}
              <span className="s1">{howItWorks.highlight}</span>
            </h2>
          </div>

          <div className="snft-content">
            {howItWorksData.map((item, index) => (
              <div className="snft-item" key={index}>
                <div className="how-works-heading">
                  <div className="snft-icon">
                   <img src={item.icon} alt="" /> 
                  </div>
                  <div>
                    <div className="step-span">{item.step}</div>
                    <h4 className="all-h4">{item.title}</h4>
                  </div>
                </div>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= PROJECTS ================= */}
      <section className="Ourprojects" id="Technology">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section_title text-center">
                <div className="sec-title mx-auto"><MdTrendingUp size={20} className="all-icon" />{projects.tag}</div>
                <h2 className="title all-h2">
                  {projects.title}
                  <span className="s1">{projects.highlight}</span>
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="cards-wrapper">
                {cardsData.map((card, index) => {
                  const layoutType = index % 6; 
                  return (
                    <div className={`ai-card layout-${layoutType}`} key={index}>

                      {/* ===== Pattern 1 ===== */}
                      {layoutType === 0 && (
                        <>
                          <div className="aicard-content">
                            <h4 className="all-h4">{card.title}</h4>
                            <p>{card.desc}</p>
                          </div>

                          <div className="image-box"> 
                            <img src="/images/projects/project-1.jpg" alt={card.title} />
                          </div>
                        </>
                      )}

                      {/* ===== Pattern 2 ===== */}
                      {layoutType === 1 && (
                        <>
                          <div className="image-box"> 
                            <img src="/images/projects/project-2.jpg" alt={card.title} />
                          </div>

                          <div className="aicard-content">
                            <h4 className="all-h4">{card.title}</h4>
                            <p>{card.desc}</p>
                          </div>
                        </>
                      )}

                      {/* ===== Pattern 3 ===== */}
                      {layoutType === 2 && (
                         <>
                          <div className="aicard-content">
                            <h4 className="all-h4">{card.title}</h4>
                            <p>{card.desc}</p>
                          </div>

                          <div className="image-box"> 
                            <img src="/images/projects/project-3.jpg" alt={card.title} />
                          </div>
                        </>
                      )}
                      
                       {/* ===== Pattern 4 ===== */}
                      {layoutType === 3 && (
                        <>
                          <div className="aicard-content">
                            <h4 className="all-h4">{card.title}</h4>
                            <p>{card.desc}</p>
                          </div>

                          <div className="image-box"> 
                            <img src="/images/projects/project-4.jpg" alt={card.title} />
                          </div>
                        </>
                      )}

                       {/* ===== Pattern 5 ===== */}
                      {layoutType === 4 && (
                        <> 
                          <div className="image-box"> 
                            <img src="/images/projects/project-5.jpg" alt={card.title} />
                          </div>

                           <div className="aicard-content">
                            <h4 className="all-h4">{card.title}</h4>
                            <p>{card.desc}</p>
                          </div>
                        </>
                      )}

                      {/* ===== Pattern 6 ===== */}
                      {layoutType === 5 && (
                        <>
                          <div className="aicard-content">
                            <h4 className="all-h4">{card.title}</h4>
                            <p>{card.desc}</p>
                          </div>

                          <div className="image-box"> 
                            <img src="/images/projects/project-6.jpg" alt={card.title} />
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>

            </div>
          </div>
        </div>
      </section> 

      {/* ================= Ourtimeline ================= */}
      <section className="Ourtimeline" id="roadmap">
        <div className="container">
          {/* SECTION HEADING */}
          <div className="row">
            <div className="col-lg-12">
              <div className="section_title text-center">
                <div className="sec-title mx-auto"><MdTrendingUp size={20} className="all-icon" />
                  {timelineSectionData.tag}
                </div> 
                <h2 className="title all-h2">
                  {timelineSectionData.heading.normal}{" "}
                  <span className="s1">
                    {timelineSectionData.heading.highlight}
                  </span>
                </h2>
              </div>
            </div>
          </div>

          {/* TIMELINE */}
          <div className="row">
            <div className="col-md-12">
              <div className="main-timeline">

                {timelineSectionData.timelines.map((item, index) => (
                  <div className="timeline" key={index}>
                    <div className="timeline-content">
                 <div className="timeline-content-small">  
                      <div className="timeline-icon">
                        <img src={item.icon} alt={item.phase} />
                      </div>

                      <div className="sec-title"><MdTrendingUp size={20} className="all-icon" />{item.phase}</div>
                      <h4 className="all-h4">{item.title}</h4>

                      <ul className="all-ul">
                        {item.points.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                 </div>

                    </div>
                  </div>
                ))}

              </div>
            </div>
          </div>

        </div>
      </section> 

      {/* ================= FAQ ================= */}
      <section className="what-nft" id="faq">
        <div className="container">
          {/* SECTION HEADING */}
          <div className="row ">
            <div className="col-lg-12">
              <div className="section_title text-center">
                <div className="sec-title mx-auto"><MdTrendingUp size={20} className="all-icon" />
                  {faqSectionData.tag}
                </div> 
                <h2 className="title all-h2">
                  {faqSectionData.heading.normal}{" "}
                  <span className="s1">
                    {faqSectionData.heading.highlight}
                  </span>
                </h2>
              </div>
            </div>
          </div>

          {/* FAQ ACCORDION */}
          <div className="row row-reverse">
             <div className="col-lg-6">
              <div className="right-image">
                <div className="glow"></div>
                <img src="/images/about/faq.png" alt="" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="custom-accordion" id="accordion"> 
                {faqSectionData.items.map((item, i) => {
                  const isOpen = openIndex === i; 
                  return (
                    <div className="panel panel-default" key={i}>
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <button
                            className={`accordion-btn ${!isOpen ? "collapsed" : ""
                              }`}
                            onClick={() =>
                              setOpenIndex(isOpen ? -1 : i)
                            }
                          >
                            {item.title}
                          </button>
                        </h4>
                      </div>

                      {isOpen && (
                        <div className="panel-collapse">
                          <div className="panel-body">
                            <p>{item.content}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}

              </div>
            </div>
          </div>

        </div>
      </section>

 
    </>
  );
};

export default BannerSection;